import React, {memo, useState, useEffect, useCallback} from "react";
import {useSelector} from "react-redux";
//components:
import {ImagesGroup, NetgraphNavbarBadges} from "../../../widgets";

const NetgraphNavbar = ({
    page,
    insightsOptions,
    selectedInsights,
    setSelectedInsights,
    setNetgraphDataFilteredBySpeakers,
    showModal,
}) => {
    const {info = {}, netGraphData = [], netgraphDataLoading = false, netgraphConfigLoading = false} = useSelector(
        state => state.mediaItemPage
    );

    const isDocument = info?.type_id === 2;
    const showSpeakersBadge = page === "review" && !isDocument;
    const isVideoPage = page === "videos";

    const [avatars, setAvatars] = useState([]);

    useEffect(() => {
        const netgraphHasData = netGraphData && Object.keys(netGraphData).length !== 0;

        const speakers = netgraphHasData
            ? netGraphData.map((speaker, i) => ({
                  id: speaker.id,
                  name: speaker.name,
                  media_url: speaker.media_url,
                  active: i === 0,
              }))
            : [];

        setAvatars(speakers);
    }, [netGraphData]);

    useEffect(() => {
        const filterNetgraphData =
            Array.isArray(netGraphData) &&
            netGraphData.filter(({id}) => avatars.some(avatar => avatar.id === id && avatar.active === true));

        setNetgraphDataFilteredBySpeakers(filterNetgraphData);
    }, [avatars]);

    const onAvatarClick = useCallback(
        speaker => {
            const speakerToToggle = avatars.find(sp => sp.id === speaker.id);
            const activeSpeakers = avatars.filter(sp => sp.active);
            const isLastActiveSpeaker = activeSpeakers?.length === 1 && activeSpeakers?.[0] === speakerToToggle;

            if (!isLastActiveSpeaker) {
                const toggledSpeaker = {
                    ...speakerToToggle,
                    active: !speakerToToggle.active,
                };
                const updatedSpeakersList = avatars.map(sp => (sp === speakerToToggle ? toggledSpeaker : sp));

                setAvatars(updatedSpeakersList);
            }
        },
        [avatars]
    );

    return (
        <div
            className={`category-network-chart-top videopage_netgraph_navbar ${
                isVideoPage ? "under_searchbar" : "reviewPage"
            } ${showModal ? "z-index-10" : ""}`}
        >
            <div className="badges_container">
                <NetgraphNavbarBadges
                    showSpeakersBadge={showSpeakersBadge}
                    insightsOptions={insightsOptions}
                    selectedInsights={selectedInsights}
                    setSelectedInsights={setSelectedInsights}
                />
            </div>

            {!isDocument ? (
                <ImagesGroup
                    isLoading={netgraphDataLoading || netgraphConfigLoading}
                    className="mediaItemPage"
                    // placeholder={t("MODAL.SPEAKERS_SELECTOR.EMPTY")}
                    type="speakers"
                    images={avatars}
                    max={4}
                    toggleImage={onAvatarClick}
                />
            ) : null}
        </div>
    );
};

export default memo(
    NetgraphNavbar,
    (prevProps, nextProps) =>
        prevProps.showModal === nextProps.showModal &&
        prevProps.page === nextProps.page &&
        prevProps.netGraphData === nextProps.netGraphData &&
        prevProps.insightsOptions === nextProps.insightsOptions &&
        prevProps.selectedInsights === nextProps.selectedInsights
);
